module.exports = __webpack_public_path__ + "img/뉴에이징플랫폼자문.052eef74.png";